import styles from './Labeled.module.scss';

const Labeled = ({
  children,
  width,
  center = false,
}: {
  children: React.ReactNode;
  width?: string;
  center?: boolean;
}) => {
  return (
    <div
      style={{ width: width, alignItems: center ? 'center' : 'flex-start' }}
      className={styles.labeled}
    >
      {children}
    </div>
  );
};

export default Labeled;
